module.exports = __webpack_public_path__ + "img/icon-work.017bc1a6.png";